<template>
  <div>
    <h1>Om tjenesten</h1>
    <p>
      Her kan du abonnere på naturfarevarsler fra norske myndigheter. Ved å
      tegne abonnement vil du motta varsler på e-post og/eller SMS med en gang
      varsler er publisert på varsom.no i henhold til de reglene du selv har
      bestemt. E-posten og SMS-en du mottar inneholder lenke til varselet på
      varsom.no. Klikk alltid på lenken og les varselet der. Informasjonen i
      e-post/SMS alene er svært begrenset.
    </p>
    <p>
      Du kan selv bestemme hvilke naturfarer du vil abonnere på, område
      (kommune, fylke eller region), laveste varslingsnivå og hvordan du vil
      motta (e-post og/eller SMS).
    </p>
    <p>
      Tjenesten omfatter varsel om flom, jordskredfare (jord-, sørpe- og
      flomskred), snøskredfare og fjellskredfare fra Norges vassdrags- og
      energidirektorat, samt farevarsel om regn, styrtregn, snø, snøfokk, is,
      vindkast på land, skogbrann, vannstand langs kysten og i fjordene, lyn og
      polart lavtrykk fra Meteorologisk institutt.
    </p>
    <p>
      For å abonnere må du først opprette en bruker med brukernavn lik den
      epost-adressen du vil motta varsler på. Du kan deretter tegne de
      abonnementene du ønsker. Du administrerer selv alle abonnementene dine,
      herunder bl.a. område du abonnerer på og hvordan du ønsker å motta
      varslene. Du kan når som helst stoppe abonnementene dine. Du kan også selv
      slette brukeren din hvis du ønsker det, under fanen NVE KONTO.
      <br />Hvis du vil motta varsler på ny epost-adresse må du opprette ny
      bruker med den epost-adressen, og tegne de abonnementene du ønsker, for
      den nye brukeren.
    </p>
    <p>
      Tjenesten eies av Norges vassdrags- og energidirektorat (NVE) og er
      utviklet i samarbeid med Meteorologisk institutt (MET) og Statens vegvesen
      (SVV).
    </p>
    <p>
      Har du spørsmål om tjenesten, kontakt
      <a href="mailto:varsom-abonner@nve.no">varsom-abonner@nve.no</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "OmTjenesten",
};
</script>
